/*
 *  Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

export const gclidPersister = (url: string) => {
  const query = new URLSearchParams(url);
  const gclid = query.get("gclid");
  const campaign = query.get("utm_campaign");
  if (localStorage.getItem("gclid") === null || localStorage.getItem("gclid") === "not set") {
    localStorage.setItem("gclid", gclid || campaign || "not set");
  }
  return gclid;
};
